<template>
    <Modal :id="id" :open="show" :size="'modal-xl'" customSizeWid="" :FooterDefault="false" :ClassBG="true" customModalBody="" :customModalMain="'z-index:1054'">
        <template v-slot:header>
            <h6 class="modal-title">Vincular Cadastro</h6>
            <button type="button" class="btn" data-bs-dismiss="modal" aria-label="Close">
                <i class="fas fa-times btn-close-style-v2 hover-effect"></i>
            </button>
        </template>
        <template v-slot:body>
            <div class="row" >
                <Form ref="form_pessoa" @submit="submitFormPessoa">
                    <div class="row fundo-panel">
                        <div class="row mt-3">
                            <div class="col">
                                <label class="form-label">Nome *</label>
                                <Field name="nmNome" label="Nome" type="text"
                                       class="form-control shadow-v2"
                                       :class="{ filled: pessoa_crud.nmNome }"
                                       v-model="pessoa_crud.nmNome" required />
                                <ErrorMessage name="nmNome" class="form-error" v-show="showErrorMessage" />
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-6">
                                <label class="form-label">{{ dadosCadastro.tpCadastro === 'J' ? 'CNPJ' : 'CPF' }} *</label>
                                <Field v-maska="'###.###.###-##'" name="nrCpf" label="CPF" type="text"
                                       class="form-control shadow-v2" :class="{ filled: pessoa_crud.nrCpfCnpj }"
                                       v-model="pessoa_crud.nrCpfCnpj" />
                                <ErrorMessage name="nrCpf" class="form-error" v-show="showErrorMessage" />
                            </div>
                            <div class="col-6">
                                <label class="form-label">Data Nascimento *</label>
                                <DateInput v-model="pessoa_crud.dtNascimento" class="col-12"
                                           :customWidth="customWidthDate" dateFormat="DD/MM/YYYY" />
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col">
                                <label for="dsEmail" class="form-label">E-mail *</label>
                                <Field name="dsEmail" label="E-mail" type="text" class="form-control shadow-v2" v-model="pessoa_crud.dsEmail" />
                                <ErrorMessage name="dsEmail" class="form-error" v-show="showErrorMessage" />
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col">
                                <label class="form-label">Telefone</label>
                                <Field name="nrTelefone" label="nrTelefone" type="text" class="form-control shadow-v2"
                                       :class="{ filled: pessoa_crud.nrTelefone }"
                                       v-maska="'(##) ####-####'" v-model="pessoa_crud.nrTelefone" />
                            </div>
                            <div class="col">
                                <label class="form-label">Celular</label>
                                <Field name="nrCelular" label="nrCelular" type="text" class="form-control shadow-v2"
                                       :class="{ filled: pessoa_crud.nrCelular }"
                                       v-maska="'(##) #####-####'" v-model="pessoa_crud.nrCelular" />
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col">
                                <label class="form-label">Cidade</label>
                                <Field name="nmCidade" label="Cidade" type="text" class="form-control shadow-v2"
                                       :class="{ filled: pessoa_crud.nmCidade }"
                                       v-model="pessoa_crud.nmCidade"
                                        />
                            </div>
                            <div class="col">
                                <label class="form-label">UF</label>
                                <Field name="nmUf" label="Estado" type="text" class="form-control shadow-v2"
                                       :class="{ filled: pessoa_crud.nmUf }" v-model="pessoa_crud.nmUf"
                                        />
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-6">
                                <label class="form-label">Logradouro</label>
                                <Field name="dsEndereco" label="Logradouro" type="text"
                                       class="form-control shadow-v2"
                                       :class="{ filled: pessoa_crud.dsEndereco }"
                                       v-model="pessoa_crud.dsEndereco"
                                        />
                            </div>
                            <div class="col-3">
                                <label class="form-label">Numero</label>
                                <Field name="nrNumero" label="Numero" type="text" id="nrNumber"
                                       class="form-control shadow-v2" :class="{ filled: pessoa_crud.nrNumero }"
                                       v-model="pessoa_crud.nrNumero" ref="numeroResidenciaInput" />
                            </div>
                            <div class="col">
                                <label class="form-label">Bairro</label>
                                <Field name="nmBairro" label="Bairro" type="text" class="form-control shadow-v2"
                                       :class="{ filled: pessoa_crud.nmBairro }"
                                       v-model="pessoa_crud.nmBairro"
                                        />
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col">
                                <label class="form-label">Complemento</label>
                                <Field name="dsComplemento" label="Complemento" type="text"
                                       class="form-control shadow-v2"
                                       :class="{ filled: pessoa_crud.dsComplemento }"
                                       v-model="pessoa_crud.dsComplemento" />
                            </div>
                            <div class="col-3">
                                <label class="form-label">CEP</label>
                                <Field v-maska="'#####-###'" name="dsCep" id="dsCep" label="CEP" type="text"
                                       class="form-control shadow-v2" :class="{ filled: pessoa_crud.dsCep }"
                                       v-model="pessoa_crud.dsCep"
                                       @focusout="getCEP(pessoa_crud.dsCep)" />
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
        </template>
        <template v-slot:footer>
            <div class="modal-footer">
                <button type="button" class="btn btn-close-clean-v2 mt-2" data-bs-dismiss="modal">
                    Fechar
                </button>
                <button type="button" class="btn btn-red-v2" @click="submitFormPessoa">
                    <i class="fas fa-save pe-2"></i>
                    Salvar
                </button>
            </div>
        </template>
    </Modal>
</template>

<script>
    import Modal from "@/components/App/Modal.vue";
    import axios from "axios";
    import DateInput from "@/components/App/DateInput.vue";

    export default {
        name: "VincularCadastro",
        components: {
            Modal, DateInput
        },
        props: {
            show: {
                type: Boolean,
                default: false
            },
            dadosCadastro: {
                type: Object,
                default() {
                    return {
                        tpCadastro: '',
                        nrCpfCnpj: '',
                        nmPessoa: '',
                        dtNascimento: '',
                        dsEmail: '',
                        nrTelefone: '',
                        nrCelular: '',
                        nmCidade: '',
                        nmUf: '',
                        dsEndereco: '',
                        nrNumero: '',
                        nmBairro: '',
                        dsComplemento: '',
                        dsCep: '',
                        idVinculo: '',
                        idDepartamento: '',
                        idFuncao: '',
                    }
                },
            },
            callback: {
                type: Function,
                default() {
                    return null;
                }
            },
            id: {
                type: String,
                default: "vincular_cadastro"
            },
        },
        data() {
            return {
                pessoa_crud: {},
                customWidthDate: '',
                showErrorMessage: false,
            };
        },
        methods: {
            getDados() {
                this.pessoa_crud = {
                    tpCadastro: this.dadosCadastro.tpCadastro,
                    nmNome: this.dadosCadastro.nmPessoa,
                    nrCpfCnpj: this.dadosCadastro.nrCpfCnpj,
                    dtNascimento: this.dadosCadastro.dtNascimento,
                    dsEmail: this.dadosCadastro.dsEmail,
                    nrTelefone: this.dadosCadastro.nrTelefone,
                    nrCelular: this.dadosCadastro.nrCelular,
                    nmCidade: this.dadosCadastro.nmCidade,
                    nmUf: this.dadosCadastro.nmUf,
                    dsEndereco: this.dadosCadastro.dsEndereco,
                    nrNumero: this.dadosCadastro.nrNumero,
                    nmBairro: this.dadosCadastro.nmBairro,
                    dsComplemento: this.dadosCadastro.dsComplemento,
                    dsCep: this.dadosCadastro.dsCep,
                };
            }, 

            getCEP(value) {
                let $this = this;

                axios.get('https://viacep.com.br/ws/' + value + '/json/', {
                    headers: $this.$api.getTokenComercial(),
                    params: ''
                }).then(response => {
                    $this.pessoa_crud = {
                        ...$this.pessoa_crud,
                        dsCep: response.data.cep,
                        nmCidade: response.data.localidade,
                        nmUf: response.data.uf,
                        dsEndereco: response.data.logradouro,
                        nmBairro: response.data.bairro
                    };
                });
            },

            submitFormPessoa() {
                let $this = this;

                $this.$refs.form_pessoa.validate()
                    .then(isValid => {

                        if (!$this.$phoneValidator.validatePhoneCell($this.pessoa_crud.nrTelefone, $this.pessoa_crud.nrCelular)) {
                            $this.$toast.show('alert', 'Telefone ou celular � obrigat�rio e deve estar completo!', true);
                            return;
                        }   

                        if (isValid.valid) {
                            axios.post(process.env.VUE_APP_ROOT_EVENTOS_API + '/Inscricao/PostVinculoCadastro', $this.pessoa_crud, { headers: $this.$api.getTokenEventos() })
                                .then(function (response) {
                                    $this.fecha_modal();
                                    $this.callback(response.data.data);
                                })
                                .catch(function (error) {
                                    var msg = 'Ocorreu um erro inesperado';
                                    if (error.response) {
                                        if (error.response.data.erros != '') {
                                            msg = error.response.data.errors[0];
                                        } else {
                                            msg = error.response.data.msg;
                                        }
                                    }

                                    $this.$toast.show('alert', msg, true);
                                });
                            $this.showErrorMessage = false;
                        } else {
                            throw new Error();
                        }
                    })
                    .catch(error => {
                        var msg = 'Por favor, preencha todos os campos obrigat�rios.';
                        if (error.response) {
                            if (error.response.data.erros != '') {
                                msg = error.response.data.errors[0];
                            } else {
                                msg = error.response.data.msg;
                            }
                        }
                        $this.showErrorMessage = true;
                        $this.$toast.show('alert', msg, true);
                    });
            },
            fecha_modal() {
                var myModalEl = document.getElementById(this.id);
                var modal = window.bootstrap.Modal.getInstance(myModalEl);
                modal.hide();
            },
        },
        mounted() {
            this.getDados();
        },
        watch: {
            show(n, o) {
                if (n) {
                    this.getDados();
                }
            },
        },
    };

</script>

<style scoped lang="scss">
    
</style>